import { useEffect } from 'react'

const siteUrl = 'https://www.phonetoo.cn'

function setMeta(selector, attributes) {
  let element = document.head.querySelector(selector)
  if (!element) { element = document.createElement('meta'); document.head.appendChild(element) }
  Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value))
}

export default function SEO({ title, description, path = '/', type = 'website', schema }) {
  useEffect(() => {
    const fullTitle = title.includes('宏图机电') ? title : `${title}｜宏图机电`
    const canonical = `${siteUrl}${path}`
    document.title = fullTitle
    setMeta('meta[name="description"]', { name: 'description', content: description })
    setMeta('meta[property="og:title"]', { property: 'og:title', content: fullTitle })
    setMeta('meta[property="og:description"]', { property: 'og:description', content: description })
    setMeta('meta[property="og:type"]', { property: 'og:type', content: type })
    setMeta('meta[property="og:url"]', { property: 'og:url', content: canonical })
    let link = document.head.querySelector('link[rel="canonical"]')
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link) }
    link.href = canonical
    const id = 'page-structured-data'
    document.getElementById(id)?.remove()
    if (schema) { const script = document.createElement('script'); script.id = id; script.type = 'application/ld+json'; script.textContent = JSON.stringify(schema); document.head.appendChild(script) }
    return () => document.getElementById(id)?.remove()
  }, [title, description, path, type, schema])
  return null
}
